module.exports = __webpack_public_path__ + "static/media/rainy-3.6b26f41e.svg";